module.exports = __webpack_public_path__ + "img/no-draft.ef8ee3c4.png";